var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-popover',{attrs:{"placement":"bottom","width":"200","trigger":"hover","content":_vm.reason,"disabled":!_vm.isPopver}},[_c('div',{class:['tag fz-12 nowrap radius-4', _vm.classStyle],attrs:{"slot":"reference"},slot:"reference"},[_c('span',[_vm._v(_vm._s(_vm.desc))]),(_vm.isPopver)?_c('i',{staticClass:"el-icon-arrow-right"}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }